import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/Register',
        name: 'Register',
        component: () => import('@/views/Register.vue')
    },
    {
        path: '/ResetPassword',
        name: 'ResetPassword',
        component: () => import('@/views/ResetPassword.vue')
    },
    {
        path: '/Dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/Renewal',
        name: 'Renewal',
        component: () => import('@/views/Renewal.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/Admin/Dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: {
            requiresAdmin: true
        }
    },
    {
        path: '/MyAccount',
        name: 'MyAccount',
        component: () => import('@/views/MyAccount.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/ThankYou',
        name: 'ThankYou',
        component: () => import('@/views/ThankYou.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/VerifyEmail',
        name: 'VerifyEmail',
        component: () => import('@/views/VerifyEmail.vue')
    },
    {
        path: '/ForgotPassword',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword.vue')
    },
    {
        path: '/Privacy',
        name: 'Privacy',
        component: () => import('@/views/Privacy.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeResolve((to, from, next) => {
    if ((to.meta?.requiresAuth ?? false) && !(store.getters.isAdmin || store.getters.isUser)) {
        next({ name: 'Login' })
    } else if ((to.meta?.requiresAdmin ?? false) && !store.getters.isAdmin) {
        next({ name: 'Dashboard' })
    } else {
        next()
    }
})

export default router
